import React from 'react';

function SectionHeader({ eyebrow, title, children, align = 'left', className = '' }) {
  const alignment = align === 'center' ? 'mx-auto text-center' : '';

  return (
    <div className={['max-w-3xl', alignment, className].join(' ')}>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="mt-3 section-title">{title}</h2>
      {children && <div className="mt-4 section-copy">{children}</div>}
    </div>
  );
}

export default SectionHeader;
